export default class Sources {
  static readonly ifj: string = 'ifj';
  static readonly bekb: string = 'bekb';
  static readonly tkb: string = 'tkb';
  static readonly zugerkb: string = 'zugerkb';
  static readonly sgkb: string = 'sgkb';
  static readonly akb: string = 'akb';
  static readonly sg: string = 'sg';
  static readonly gch: string = 'gch';
  static readonly rbsg: string = 'rbsg';


  static readonly levanteSourcesExcludingIfj: string[] = [Sources.bekb, Sources.tkb, Sources.zugerkb, Sources.sgkb, Sources.akb, Sources.sg, Sources.gch, Sources.rbsg];
}
